import { useEffect, useRef } from 'react';

// The header Back button fires a cancelable 'app-back' event first. A page that
// has an inner view open (a selected item, a section) closes it and cancels the
// event, so Back returns to that page's own list instead of leaving the page.
export function useAppBack(active, onBack) {
  const handler = useRef(onBack);
  handler.current = onBack;
  useEffect(() => {
    if (!active) return undefined;
    const listener = (e) => { e.preventDefault(); handler.current(); };
    window.addEventListener('app-back', listener);
    return () => window.removeEventListener('app-back', listener);
  }, [active]);
}

export function dispatchAppBack() {
  return window.dispatchEvent(new Event('app-back', { cancelable: true }));
}
